import { Select } from 'antd';
import Icon from 'common/components/IconFont';
import * as React from 'react';
import languages from './utils/languages';
const Option = Select.Option;

interface iProps {
    language?: string;
    style?: Object;
    showIcon?: boolean;
}

export default function Selector(props: iProps) {
    let { language, style, showIcon } = props;
    // 当前语言
    language = language || languages.getDefault();
    // 支持语言
    const locales: any = languages.getDisplay()
        .reduce((prev: any, { key, name, icon }: any) => ({ ...prev, [key]: { icon: icon, name: name } }), {});
    // 选择语言
    const languageChangeHandler = async (language: any) => {
        await languages.set(language);
    };
    return (
        <div className="i18nSelector" style={style}>
            {showIcon
                ? <Icon className='i18nSelector-item-text anticon-11' />
                : <Select onChange={languageChangeHandler} value={language} optionLabelProp="label">
                    {Object.entries(locales).map(([value, { name }]: any) => (
                        <Option key={value} value={value}
                            label={<label><Icon className="anticon-11" />{name}</label>}
                        >{name}</Option>
                    ))}
                </Select>
            }
        </div>
    );
}
